<template>
  <div class="seckill-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input
          v-model="searchParams.prodNameLike"
          :placeholder="$t('seckill.productNamePlaceholder')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="margin-top"
    >
      <el-table-column prop="shopName" :label="$t('goods.seckill.shop')" align="center"></el-table-column>
      <el-table-column prop="prodName" :label="$t('goods.seckill.productName')" align="center"></el-table-column>
      <el-table-column prop="killHours" :label="$t('goods.seckill.hours')" align="center"></el-table-column>
      <el-table-column prop="continueHours" :label="$t('goods.seckill.duration')" align="center"></el-table-column>
      <el-table-column prop="totalCount" :label="$t('goods.seckill.limit')" align="center"></el-table-column>
      <el-table-column prop="oneCount" :label="$t('goods.seckill.singlePurchase')" align="center"></el-table-column>
      <el-table-column :label="$t('goods.seckill.seckillPrice')" align="center">
        <template #default="scope">
          {{ `￥${scope.row.killPrice}` }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('goods.seckill.originalPrice')" align="center">
        <template #default="scope">
          {{ `￥${scope.row.price}` }}
        </template>
      </el-table-column>
      <el-table-column prop="killStock" :label="$t('goods.seckill.stock')" align="center"></el-table-column>
      <el-table-column prop="state" :label="$t('goods.seckill.status')" align="center">
        <template #default="scope">
          {{ scope.row.state === '1001' ? $t('common.enable') : $t('common.disable') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('goods.seckill.timeRange')" align="center">
        <template #default="scope">
          {{ `${scope.row.startTime}~${scope.row.endTime}` }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="margin-top"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
  </div>
</template>

<script>
import { getSeckillList } from '@/api/goods/seckillApi'

export default {
  name: 'AShopDetailSeckill',

  data() {
    return {
      searchParams: {
        prodNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          prodNameLike: this.searchParams.prodNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        
        const res = await getSeckillList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取秒杀商品列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.seckill-container {
}
.search-row {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
</style>